import yachtTypesApiService from '@/services/api/YachtTypes'

const emptyModel = {
  label: null,
  cost_data: null
}

const emptyFilters = {
  label: null
}

const COST_ELEMENT_OPERATIONAL = 'operational'
const COST_ELEMENT_INSURANCE = 'insurance'
const COST_ELEMENT_DOCKAGE = 'dockage'
const COST_ELEMENT_SERVICE = 'service'
const COST_ELEMENT_HAUL = 'haul'
const COST_ELEMENT_OFFSEASON = 'off_season'
const COST_ELEMENT_SAILS = 'sails'
const COST_ELEMENT_LICENSE = 'license'

const CALCULATION_TYPE_FIXED = 'fixed'
const CALCULATION_TYPE_PER_FT = 'per_ft'
const CALCULATION_TYPE_PERCENTAGE_OF_VALUE = 'percentage_of_value'
const CALCULATION_TYPE_PERCENTAGE_OF_INCOME = 'percentage_of_income'

const costModel = {
  cost_element_key: null,
  calculation_type: null,
  value: null
}

const COST_DATA = {
  [COST_ELEMENT_OPERATIONAL]: {
    label: 'Operational costs',
    key: COST_ELEMENT_OPERATIONAL
  },
  [COST_ELEMENT_INSURANCE]: {
    label: 'Insurance',
    key: COST_ELEMENT_INSURANCE
  },
  [COST_ELEMENT_DOCKAGE]: {
    label: 'Dockage, Water, Electricity',
    key: COST_ELEMENT_DOCKAGE
  },
  [COST_ELEMENT_SERVICE]: {
    label: 'Estimated Service costs',
    key: COST_ELEMENT_SERVICE
  },
  [COST_ELEMENT_HAUL]: {
    label: 'Haul - Launch/ft',
    key: COST_ELEMENT_HAUL
  },
  [COST_ELEMENT_OFFSEASON]: {
    label: 'Off season storage',
    key: COST_ELEMENT_OFFSEASON
  },
  [COST_ELEMENT_LICENSE]: {
    label: 'Annual License',
    key: COST_ELEMENT_LICENSE
  }
}

const CALCULATION_TYPE_DATA = {
  [CALCULATION_TYPE_FIXED]: {
    label: 'Fixed',
    key: CALCULATION_TYPE_FIXED
  },
  [CALCULATION_TYPE_PER_FT]: {
    label: 'Per ft',
    key: CALCULATION_TYPE_PER_FT
  },
  [CALCULATION_TYPE_PERCENTAGE_OF_VALUE]: {
    label: '% of yacht value',
    key: CALCULATION_TYPE_PERCENTAGE_OF_VALUE
  },
  [CALCULATION_TYPE_PERCENTAGE_OF_INCOME]: {
    label: '% of income',
    key: CALCULATION_TYPE_PERCENTAGE_OF_INCOME
  }
}

export default class YachtType {
  static api = yachtTypesApiService
  static emptyModel = emptyModel
  static emptyFilters = emptyFilters
  static costModel = costModel

  static COST_ELEMENT_OPERATIONAL = COST_ELEMENT_OPERATIONAL
  static COST_ELEMENT_INSURANCE = COST_ELEMENT_INSURANCE
  static COST_ELEMENT_DOCKAGE = COST_ELEMENT_DOCKAGE
  static COST_ELEMENT_SERVICE = COST_ELEMENT_SERVICE
  static COST_ELEMENT_HAUL = COST_ELEMENT_HAUL
  static COST_ELEMENT_OFFSEASON = COST_ELEMENT_OFFSEASON
  static COST_ELEMENT_SAILS = COST_ELEMENT_SAILS
  static CALCULATION_TYPE_FIXED = CALCULATION_TYPE_FIXED
  static CALCULATION_TYPE_PER_FT = CALCULATION_TYPE_PER_FT
  static CALCULATION_TYPE_PERCENTAGE_OF_VALUE = CALCULATION_TYPE_PERCENTAGE_OF_VALUE
  static CALCULATION_TYPE_PERCENTAGE_OF_INCOME = CALCULATION_TYPE_PERCENTAGE_OF_INCOME

  static COST_DATA = COST_DATA
  static CALCULATION_TYPE_DATA = CALCULATION_TYPE_DATA
}
